/** Etat final apres refus - le sien, ou parcours clos par un autre
 *  (annulation, refus d'un autre signataire, expiration : `titre`/`corps`).
 *  Aucune action proposee : le parcours est clos, et reproposer de signer
 *  serait insistant. */
import type { t } from "../i18n";

export function Declined({ L, titre, corps }: { L: ReturnType<typeof t>; titre?: string; corps?: string }) {
  return (
    <section className="card stack">
      <div className="alert alert--info" role="status">
        <strong>{titre ?? L.declinedTitle}</strong>
      </div>
      <p>{corps ?? L.declinedBody}</p>
    </section>
  );
}
